import React, { useState } from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import image from '../Photos/Gurudwaras-in-India.jpg';
// import khanda from '../Photos/khanda.png';
import heading from "../Photos/heading.png";
import { useHistory } from "react-router-dom";

function ResendApplicantid() {
  const [applicantNumber, setApplicantNumber] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const history = useHistory();
  const gotodashboard = () => {
    history.push("/dashboard", { verified: true });
  }

  const getApplicationStatus = () => {
    Axios.post('https://api-gsm.sikhfoundation.co.in/resendapplicantid', {
      applicantNumber: applicantNumber,
    })
      .then((response) => {
        if (response.data === true) {
          setModalMessage('Applicant ID sent to your registered Whatsapp number');
          setShowModal(true);
        } else {
          setModalMessage('Please enter your registered Whatsapp number');
          setShowModal(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="mx-3">
        <form>
          <div className=" p-3 text-primary" >
            <img src={heading} alt="" class="col-md-5 text-center img-fluid" />
          </div>
          <div className="col-md-5">
            <div className="">
              <div className="h4 pb-2 mb-4 text-primary border-bottom border-primary border-3 mx-4 text-center" id="title">Request Applicant ID</div>
              <div className="my-3 col-md-7 mx-4">
                <label className="form-label fs-5 text-primary h1">Verified WhatsApp Number</label>
                <input type="number" className="form-control justify-content-center" id="exampleInputEmail1" onChange={(event) => { setApplicantNumber(event.target.value); }} autoFocus autoComplete="off" />
              </div>

              <div className="">
                <button type="button" style={{ marginLeft: '23px' }} className="btn btn-primary fs-5" onClick={() => { getApplicationStatus(); }} data-bs-toggle="modal" data-bs-target="#exampleModal" >Send</button>
                <Link onClick={gotodashboard} className="btn btn-primary mx-1 fs-5">Back</Link>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div>
        <img src={image} alt="Image not found" className="img-fluid d-md-none mt-2" />
      </div>

      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5 text-primary" id="exampleModalLabel">
                GSM says
              </h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
            </div>
            <div className="modal-body text-primary"><b>{modalMessage}</b></div>
            <div className="modal-footer">
              <Link onClick={gotodashboard} target="_parent" type="button" className="btn btn-secondary" autoFocus>Ok</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResendApplicantid;


